export function isServerError(error) {
    return "response" in error && "result" in error && "statusCode" in error;
}
